import { NgIf } from "@angular/common";
import { Directive, effect, inject, input } from "@angular/core";
import { FlagsmithService } from "../services/flagsmith.service";
import type { NerriFeatureFlagKeys } from "../types/feature-flag-keys.type";

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[flagsmithFeature]",
    hostDirectives: [
        {
            directive: NgIf,
            inputs: ["ngIf: flagsmithFeature"]
        }
    ]
})
export class FlagsmithFeatureDirective {
    private readonly flagsmithService = inject(FlagsmithService);
    private readonly ngIfDirective = inject(NgIf);

    public readonly featureKey = input.required<NerriFeatureFlagKeys>({ alias: "flagsmithFeature" });

    constructor() {
        effect(() => {
            this.ngIfDirective.ngIf = this.flagsmithService.hasFeature(this.featureKey());
        });
    }
}
